import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import moment from "moment";
import ReactDatetimeClass from "../../utils/reactDatetime";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DATE_FORMAT, formatLocaleDateString } from "../../utils";
import { FormControlWrapper } from "./formControlWrapper";

export const fieldDateOnChange = (setValue, setSelectedDate) => (e) => {
	const selectedDate = e.local().format("YYYY-MM-DDT00:00:00Z");
	setValue(selectedDate);
	setSelectedDate(new Date(selectedDate));
};

export const FieldDate = ({
	setValue = (e) => console.log("e", e),
	fieldData: dateData,
	isDisabled,
	placeholder,
	title = "",
	tooltip,
	error,
}) => {
	const [selectedDate, setSelectedDate] = useState(
		dateData ? new Date(dateData) : null,
	);

	const handleClear = () => {
		setSelectedDate(null);
		setValue(null);
	};

	useEffect(() => {
		setSelectedDate(dateData ? new Date(dateData) : null);
	}, [dateData]);

	return (
		<FormControlWrapper
			title={title}
			tooltip={tooltip}
			data-testid="test-fieldDate"
			error={error}
		>
			<ReactDatetimeClass
				timeFormat={false}
				dateFormat={DATE_FORMAT}
				initialValue={selectedDate}
				initialViewDate={selectedDate}
				selected={selectedDate}
				closeOnSelect={true}
				input={true}
				value={selectedDate}
				onChange={fieldDateOnChange(setValue, setSelectedDate)}
				renderInput={(props, openCalendar) => (
					<DateFormControl
						{...{
							props,
							error,
							openCalendar,
							placeholder,
							isDisabled,
							setValue,
							setSelectedDate,
							selectedDate,
							handleClear,
						}}
					/>
				)}
			/>
		</FormControlWrapper>
	);
};

const DateFormControl = ({
	error,
	isDisabled,
	selectedDate,
	openCalendar,
	setValue,
	setSelectedDate,
	placeholder,
	handleClear,
	autoFocus,
}) => {
	const [nestedDate, setNestedDate] = useState(
		formatLocaleDateString(selectedDate),
	);

	useEffect(() => {
		setNestedDate(formatLocaleDateString(selectedDate));
	}, [selectedDate]);

	const onBlur = (e) => {
		const parsed = moment(e.target.value, DATE_FORMAT); // parses in the locale's field order
		if (!parsed.isValid()) return;

		const date = parsed.toDate();
		setValue(date.toISOString());
		setSelectedDate(date);
	};

	return (
		<>
			<Form.Control
				data-testid="test-fieldDateControl"
				isInvalid={!!error}
				disabled={isDisabled}
				type="text"
				value={nestedDate}
				placeholder={placeholder ?? DATE_FORMAT}
				onFocus={openCalendar}
				onBlur={onBlur}
				autoFocus={autoFocus}
				onChange={(e) => setNestedDate(e.target.value)}
			/>
			{isDisabled ? null : (
				<FontAwesomeIcon
					onClick={(e) => {
						handleClear(e);
						setNestedDate(null);
					}}
					className="dataFormControlIcon"
					variant="secondary"
					icon={faTimes}
				/>
			)}
		</>
	);
};
